import store from '@/app/store/store';
import { getGlobalValueString } from '@/app/utils/checkRoleApply.ts';
(function (jQuery) {
  jQuery.gfArv6SectionPicker = function (element, options) {
    const defaults = {
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const $cSelector = jQuery(
      '<a id="gf-button-picker" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Pick a Section</a>',
    );

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const arWidth = 500;
    const arHeight = 462;
    const windows = {};

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.gfInputField();
      if ($element.next('.gfInputField').next('#gf-button-picker').length == 0) {
        $element.next('.gfInputField').after($cSelector);
      }

      this.applyEvents();
    };

    this.applyEvents = function () {
      $cSelector.off().on('click', function (e) {
        const arWindowPositionX = window.screenX ? window.screenX + 260 : window.screenLeft + 260;
        const arWindowPositionY = window.screenY ? window.screenY + 120 : window.screenTop + 120;
        const arWindowpPostion = { X: arWindowPositionX, Y: arWindowPositionY };
        _this.openPopup(arWindowpPostion);
      });
      return false;
    };
    this.openPopup = function (position) {
      const windowName = 'ARWindow';
      if (windows[windowName]) {
        this.closeWindow(windowName);
      }
      const arWindow = window.open(
        '',
        windowName,
        `toolbar=no, screenX=${position.X}, screenY=${position.Y}, status=no,menubar=no,scrollbars=yes,resizable=yes,width=${arWidth},height=${arHeight}`,
      );
      const $gfFrame = jQuery('#gfFrame');
      let pageType = $gfFrame.data('gfframe').getPageType() || '';
      if (pageType === 'template-page') {
        // subpage
        pageType = 'review';
        // homepage
      } else if (pageType === 'template-index') {
        pageType = 'home';
      } else {
        pageType = pageType.replace('template-', '');
      }
      const page_type = pageType;
      const arv6FrameHost = getGlobalValueString('arv6IntegrateHost');
      const shopDomain = $gfFrame.data('gfframe').getShopDomain();
      const iframe_host = arv6FrameHost
        ? arv6FrameHost
        : 'https://widget.alireviews.io/api/v1/integrate/gempage/widgets';
      const iframe_url = iframe_host + '?shop_name=' + shopDomain + '&page_type=' + page_type;
      arWindow.document.write(
        `<body style="padding:0; margin:0"><iframe id="gem-arv6-portal" style="width: 100%; height: 100%;" frameBorder="0" src ="${iframe_url}"></iframe></body>`,
      );
      arWindow.document.addEventListener('GemARv6Portal', receiverARv6Event, false);
      function receiverARv6Event(event) {
        displayReceivedData(event.detail);
      }
      if (arWindow) {
        const HOST_NAME = _this.getHostname(iframe_host);
        arWindow.document.title = 'Ali Reviews V6 Section Picker';
        arWindow.addEventListener('message', (event) => {
          if (event.origin !== HOST_NAME) {
            return;
          } else {
            // if (event.data.message == "CloseAliReviewsSectionList") {
            //   this.closeWindow(windowName);
            // }
            if (event.data.message == 'AddAliReviewsSection') {
              const data = event.data;
              if (data) {
                const id = data.widget_id;
                const name = data.widget_name;
                const section = data.section;
                const snippet = data.snippet;
                this.setValue(id, name, section, snippet);
              }
            }
            if (typeof event.data == 'object') {
              this.closeWindow(windowName);
            }
          }
        });
        windows[windowName] = arWindow;
      }
    };
    this.setValue = function (id, value, liquid, snippet) {
      $element.val(value).attr('value', value);
      $element.attr('data-liquid', liquid);
      $element.attr('data-snippet', snippet);
      $element.trigger('input-change');
      const $gfInputFieldBox = $element.next('.gfInputField');
      $gfInputFieldBox.find('input').val(value);
      $gfInputFieldBox.find('textarea').val(value);
      const $arv6liquid = $element.parents('.columns').siblings().find('#arv6liquid');
      $arv6liquid.attr('default-value', liquid);
      $arv6liquid.attr('value', liquid).val(liquid).trigger('input-change');

      const $arv6snippet = $element.parents('.columns').siblings().find('#arv6snippet');
      if(snippet){
        $arv6snippet.attr('default-value', snippet);
        $arv6snippet.attr('value', snippet).val(snippet).trigger('input-change');
      }

      const $arv6SectionName = $element.parents('.columns').siblings().find('#arv6SectionName');
      $arv6SectionName.attr('default-value', value);
      $arv6SectionName.attr('value', value).val(value).trigger('input-change');

      const $arv6SectionID = $element.parents('.columns').siblings().find('#arv6SectionID');
      $arv6SectionID.attr('default-value', id);
      $arv6SectionID.attr('value', id).val(id).trigger('input-change');

      _this.settings.detectChange();
    };
    this.closeWindow = function (name) {
      const window = windows[name];
      if (window) {
        window.close();
        delete windows[name];
      }
    };
    this.getHostname = (url) => {
      // use URL constructor and return hostname
      return 'https://' + new URL(url).hostname;
    };
    this.init();
  };

  jQuery.fn.gfArv6SectionPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfarv6sectionpicker')) {
        const plugin = new jQuery.gfArv6SectionPicker(this, options);
        jQuery(this).data('gfarv6sectionpicker', plugin);
      }
    });
  };
})(jQuery);
